import { render } from "./FormGrid.vue?vue&type=template&id=10dee49b&scoped=true"
import script from "./FormGrid.vue?vue&type=script&lang=js"
export * from "./FormGrid.vue?vue&type=script&lang=js"

import "./FormGrid.vue?vue&type=style&index=0&id=10dee49b&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10dee49b"]])

export default __exports__